const TipoLog = {
  I: 'Inserção',
  A: 'Alteração',
  D: 'Exclusão',
  V: 'Visualização'
};

export default TipoLog;
